// Consistent spacing system for the application
export const spacing = {
  // Base spacing units (rem)
  xs: "1rem", // 16px
  sm: "2rem", // 32px
  md: "4rem", // 64px
  lg: "6rem", // 96px
  xl: "8rem", // 128px
  xxl: "10rem", // 160px

  // Responsive spacing
  mobile: {
    xs: "0.75rem", // 12px
    sm: "1.5rem", // 24px
    md: "2.5rem", // 40px
    lg: "4rem", // 64px
    xl: "6rem", // 96px
    xxl: "8rem", // 128px
  },

  // Component-specific spacing
  section: {
    desktop: "10rem",
    mobile: "6rem",
  },

  hero: {
    desktop: "100px",
    mobile: "40px",
  },

  content: {
    desktop: "60px",
    mobile: "40px",
  },
};

// Responsive spacing utility
export const getResponsiveSpacing = (size, isMobile = false) => {
  return isMobile ? spacing.mobile[size] : spacing[size];
};
